import { Film, Image as ImageIcon, Megaphone } from "lucide-react";
import type { ReactNode } from "react";

import classes from "./simple.module.css";

export type Kind = "image" | "video" | "ad";

interface Card {
  kind: Kind;
  title: string;
  line: string;
  icon: ReactNode;
}

const CARDS: readonly Card[] = [
  {
    kind: "image",
    title: "Image",
    line: "A picture from a few words, of your product or anything else.",
    icon: <ImageIcon size={28} strokeWidth={1.5} aria-hidden />,
  },
  {
    kind: "video",
    title: "Video",
    line: "A short clip from a few words, or from your product's photo.",
    icon: <Film size={28} strokeWidth={1.5} aria-hidden />,
  },
  {
    kind: "ad",
    title: "Ad from a template",
    line: "A ready-made ad format: fill in what it asks for.",
    icon: <Megaphone size={28} strokeWidth={1.5} aria-hidden />,
  },
];

/** Step 1: the three kinds as cards, the chosen one pressed. */
export function KindCards({ kind, onKind }: { kind: Kind | undefined; onKind: (kind: Kind) => void }) {
  return (
    <div className={classes.kinds}>
      {CARDS.map((card) => (
        <button
          key={card.kind}
          type="button"
          className={classes.kind}
          aria-pressed={kind === card.kind}
          onClick={() => onKind(card.kind)}
        >
          <span className={classes.kindIcon}>{card.icon}</span>
          <span className={classes.kindTitle}>{card.title}</span>
          <span className={classes.kindLine}>{card.line}</span>
        </button>
      ))}
    </div>
  );
}
